import script from "./AiAssistantWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiAssistantWidget.vue?vue&type=script&setup=true&lang=ts"

import "./AiAssistantWidget.vue?vue&type=style&index=0&id=820192ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-820192ae"]])

export default __exports__